import { createFileRoute } from '@tanstack/react-router';
import { JourneysBroadcastsHandoff } from '@/pages/workspaces/broadcasts/routing';
import { AppBundle } from '@/utils/app-bundles';
import { LastWorkspaceResolver } from './-components';

/**
 * The pre-rename `newsletters` spelling of the one-time sends tab, which the embedded app forwards to it. Flag off the embedded app serves it; flag on it forwards to the migrated list. The
 * resolver belongs here: this URL keeps the `journeys` segment, so a `/workspaces/last`
 * sentinel has to resolve before the embedded app mounts on it.
 */
function JourneysBroadcastsNewslettersRoute() {
  return (
    <LastWorkspaceResolver appBundle={AppBundle.Journeys}>
      <JourneysBroadcastsHandoff tab="one_time_sends" />
    </LastWorkspaceResolver>
  );
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/journeys/broadcasts/newsletters')({
  component: JourneysBroadcastsNewslettersRoute,
});
